<mat-calendar *uiRedrawOnLocaleChange
              [startAt]="startAt"
              [startView]="startView"
              [selected]="selected"
              [minDate]="viewMinDate"
              [maxDate]="viewMaxDate"
              [headerComponent]="headerComponent"
              (selectedChange)="selectDate($event)"
              (yearSelected)="selectYear($event)"
              (monthSelected)="selectMonth($event)"
              data-cy="calendar">
</mat-calendar>
